module.exports = __webpack_public_path__ + "static/img/tc-operate.0b98352.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/20250724/ruanjian/tc-operate.svg
// module id = plkz
// module chunks = 21